export const codeFields = [
  {
    name: "code",
    label: "Invite Code",
    placeholder: "Enter your code",
    component: "Input",
    required: true,
    transformOnChange: (val: string) => val.toUpperCase().replace(/\s+/g, ""),
  },
];
